import {defineStore} from "pinia";
import {api} from "../services/api";
import {isTokenExpired} from "../utils/jwt";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        accessToken: localStorage.getItem("access_token"),
        user: JSON.parse(localStorage.getItem("user") || "null"),
    }),
    getters: {
        isAuthenticated: (state) => Boolean(state.accessToken) && !isTokenExpired(state.accessToken),
    },
    actions: {
        setSession(payload) {
            this.accessToken = payload.accessToken;
            this.user = payload.user;
            localStorage.setItem("access_token", payload.accessToken);
            localStorage.setItem("user", JSON.stringify(payload.user));
        },
        async register(form) {
            const {data} = await api.post("/auth/register", form);
            this.setSession(data);
        },
        async login(form) {
            const {data} = await api.post("/auth/login", form);
            this.setSession(data);
        },
        async refresh() {
            const {data} = await api.post("/auth/refresh");
            this.setSession(data);
        },
        clearSession() {
            this.accessToken = null;
            this.user = null;
            localStorage.removeItem("access_token");
            localStorage.removeItem("user");
        },
        async logout() {
            await api.post("/auth/logout").catch(() => {});
            this.clearSession();
        },
    },
});
